export default "__VITE_ASSET__$EkbRudG__"